// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-cover img{text-align:center !important;aspect-ratio:555/670;-o-object-fit:cover;object-fit:cover;max-height:calc(100vh - 25rem);background-size:100% !important;box-shadow:0.3rem 0.4rem 2rem 0.2rem rgba(0,0,0,0.5);border-top-right-radius:25px;border-bottom-right-radius:25px}.current-cover h4{margin-top:2rem;font-family:'GFS Didot';font-style:italic;color:#616161}.current-cover button.pill{font-size:14px;padding:6px 12px;margin-bottom:10px}\n", ""]);
// Exports
module.exports = exports;
